module.exports = __webpack_public_path__ + "static/img/image027.7860393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image027.png
// module id = GgPs
// module chunks = 1